import { SvgIcon, SvgIconProps } from "@material-ui/core";

export default (props: SvgIconProps) =>
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30">
        <circle cx="15" cy="15" r="14.5" fill="#fff" stroke="#367BF5" />
        <path fill="#367BF5" d="M16 10c0-.552-.448-1-1-1s-1 .448-1 1v4h-4c-.552 0-1 .448-1 1s.448 1 1 1h4v4c0 .552.448 1 1 1s1-.448 1-1v-4h4c.553 0 1-.448 1-1s-.447-1-1-1h-4v-4z" />
    </SvgIcon>
